import { render, staticRenderFns } from "./CouponLogTables.vue?vue&type=template&id=4b2fa445&scoped=true&"
import script from "./CouponLogTables.vue?vue&type=script&lang=js&"
export * from "./CouponLogTables.vue?vue&type=script&lang=js&"
import style0 from "./CouponLogTables.vue?vue&type=style&index=0&id=4b2fa445&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2fa445",
  null
  
)

export default component.exports